// extracted by mini-css-extract-plugin
export default {"pluginHook":"PluginHook_pluginHook__yOy5Z","hookName":"PluginHook_hookName__RPFUc"};